import { mapSearchParamsToApiParams } from './MapSearchParamsToApiParams';

export const mapFrontendSearchParamsToApiParams = (frontendParams: any, isCount?: boolean) => {
  return mapSearchParamsToApiParams(frontendParams, isCount);
};
